import * as types from '../constants/actionTypes';

export function pushErrorEvent({data} = {}) {
  return {
    type: types.PUSH_ERROR_EVENT,
    data
  };
}

export function pushSuccessEvent({data} = {}) {
  return {
    type: types.PUSH_SUCCESS_EVENT,
    data
  };
}

export function pushWarningEvent({data} = {}) {
  return {
    type: types.PUSH_WARNING_EVENT,
    data
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/eventActions.js
 **/